import { mapOptionsToQueryParams } from '../../../private/services/video/video.utils';
import { PublicCatalogService } from '../../../catalog-services/public-catalog-service';
export class PublicChannelVideos extends PublicCatalogService {
    getList({ channelId, query, tag, category, mediaType, sort, paging, itemType, templateMetaSiteId, withPlayInfo, }, requestConfig) {
        const params = mapOptionsToQueryParams({
            query,
            tag,
            category,
            mediaType,
            sort,
            paging,
            itemType,
            templateMetaSiteId,
            withPlayInfo,
        });
        return this.get(`/public/lists/${channelId}`, {
            params,
            ...requestConfig,
        });
    }
    getChannelVideoById(channelId, videoId, requestConfig) {
        return this.get(`/public/lists/${channelId}/items/${videoId}/info`, requestConfig);
    }
}
//# sourceMappingURL=channel-videos.js.map